import { withSearch } from '@elastic/react-search-ui';
import MultiChoiceAsyncSelect from '../../../components/filter/MultiChoiceAsyncSelect';

function NHLEAssetTypeFilter({ addFilter, removeFilter, filters }) {
  return (
    <MultiChoiceAsyncSelect
      addFilter={addFilter}
      fieldId="assetType"
      filters={filters}
      formHint="For example, fortress, chapel, garden, barrow"
      id="asset-type"
      label="Asset type"
      removeFilter={removeFilter}
    />
  );
}

export default withSearch(({ addFilter, removeFilter, filters }) => ({
  addFilter,
  removeFilter,
  filters,
}))(NHLEAssetTypeFilter);
